module.exports = __webpack_public_path__ + "static/gallery3-47a9451daaf2b88ac8a31b0485554388.jpg";